module.exports = __webpack_public_path__ + "static/media/Media.94bb748e.svg";